import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Section, Select, cardCls, EmptyState } from "@/components/admin/ui";
import { useAuth } from "@/context/AuthContext";

const ROLES = ["ceo", "admin", "staff"];

export default function Users() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);

  const load = () => api.get("/users").then(({ data }) => setUsers(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const changeRole = async (u, role) => {
    await api.patch(`/users/${u.user_id}`, { role });
    toast.success(`${u.name} is now ${role}`);
    load();
  };

  return (
    <div data-testid="admin-users">
      <Section title="Users & Roles" subtitle="Role-based access. The Founder/CEO has full administrator permissions. Staff can be given restricted access.">
        {users.length === 0 ? <EmptyState>No users.</EmptyState> : (
          <div className={`${cardCls} divide-y divide-white/5`}>
            {users.map((u) => (
              <div key={u.user_id} data-testid={`user-row-${u.email}`} className="flex items-center gap-4 p-4">
                <div className="w-10 h-10 rounded-full bg-bd-gold/20 flex items-center justify-center text-bd-gold font-serif text-lg flex-shrink-0">{(u.name || "U")[0]}</div>
                <div className="min-w-0 flex-1">
                  <p className="text-bd-ivory truncate">{u.name}</p>
                  <p className="text-xs text-bd-ivory/40 truncate">{u.email}</p>
                </div>
                <div className="w-40">
                  <Select
                    data-testid={`user-role-${u.email}`}
                    value={u.role}
                    disabled={u.email === user?.email}
                    onChange={(e) => changeRole(u, e.target.value)}
                  >
                    {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                  </Select>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className={`${cardCls} p-6 mt-6`}>
          <h3 className="font-serif text-xl text-bd-ivory mb-3">Role permissions</h3>
          <ul className="text-sm text-bd-ivory/60 space-y-2">
            <li><span className="text-bd-gold">CEO</span> — full access to every section, users, ventures and settings.</li>
            <li><span className="text-bd-gold">Admin</span> — full management access across the group.</li>
            <li><span className="text-bd-gold">Staff</span> — restricted: CRM, tasks, enquiries and documents (no user or settings control).</li>
          </ul>
          <p className="text-xs text-bd-ivory/30 mt-4">Secure authentication is enabled with brute-force protection and is MFA-ready.</p>
        </div>
      </Section>
    </div>
  );
}
